export default __webpack_public_path__ + "static/media/warning.fc091fb4.png";